import {
  buildStyles,
  CircularProgressbarWithChildren,
} from 'react-circular-progressbar';
import IconLock from './assets/icon_lock.svg';
import IconDone from './assets/icon_done.svg';
import IconCoins from './assets/icon_coins.svg';
import s from './index.module.scss';

export const ProgressCircle = ({ isLocked, isCompleted, percentage }) => {
  return (
    <div className={s.progress}>
      <CircularProgressbarWithChildren
        value={percentage}
        strokeWidth={8}
        styles={buildStyles({
          strokeLinecap: 'butt',
          pathColor: isCompleted
            ? 'var(--Green-500-Primary, #5FC62F)'
            : 'var(--Blue-500-Primary, #FFDC37)',
          trailColor:
            percentage === 0
              ? '#FFFFFF'
              : 'var(--Grey-400-Semi-Light, #E9ECEE)',
        })}
      >
        {isLocked ? (
          <img src={IconLock} width={24} height={24} alt="lock" />
        ) : isCompleted ? (
          <img src={IconDone} width={24} height={24} alt="done" />
        ) : (
          <img src={IconCoins} width={24} height={24} alt="coins" />
        )}
      </CircularProgressbarWithChildren>
    </div>
  );
};
